export const minLength = (length)=> ({
    name: "minLength",
    validate: (value) => value != null && value.length >= length,
});
